import { apiCall } from "../../services/api-service";

export const getServiceListApi = (params) =>
  apiCall("get", `service?${params}`);

export const getWorkOrderListApi = (params) =>
  apiCall("get", `workorder?${params}`);

export const submitWOAPI = (body) =>
  apiCall("post", "workorder", body);

export const saveAttachmentApi = (id, body) =>
  apiCall("put", `workorder/add_attachment/${id}`, body);

export const updateWOAPI = (id, body) =>
  apiCall("put", `workorder/${id}`, body);

export const getWorkOrderDetailsApi = (id) =>
  apiCall("get", `workorder/view/${id}`);

export const getVehicleDetailsApi = (id) =>
  apiCall("get", `get_vehicle_details/${id}`);

export const getWorkOrderEditApi = (id) =>
  apiCall("get", `workorder/edit/${id}`);

export const getServiceReminderListApi = (params) =>
  apiCall("get", `service_reminder?${params}`);

export const getAttachmentListApi = (id) =>
  apiCall("get", `workorder/attachment/${id}`);

export const getRemoveAttachmentApi = (id) =>
  apiCall("get", `workorder/remove_attachment/${id}`);

export const submitServiceAPI = (body) =>
  apiCall("post", "service", body);

export const saveServiceAttachmentApi = (id, body) =>
  apiCall("put", `service/add_attachment/${id}`, body);

export const updateServiceAPI = (id, body) =>
  apiCall("put", `service/${id}`, body);

export const getServiceEditApi = (id) =>
  apiCall("get", `service/edit/${id}`);

export const getServiceDetailsApi = (id) =>
  apiCall("get", `service/view/${id}`);

export const submitReminderAPI = (body) =>
  apiCall("post", "service_reminder", body);

export const updateReminderAPI = (id, body) =>
  apiCall("put", `service_reminder/${id}`, body);

export const getReminderEditApi = (id) =>
  apiCall("get", `service_reminder/edit/${id}`);

export const getReminderDetailsApi = (id) =>
  apiCall("get", `service_reminder/view/${id}`);
